/* eslint-disable react/no-unstable-nested-components */
import React, { useState } from "react";
import {
    CloseOutlined
} from "@ant-design/icons";
import { Button, Radio, Switch } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RiFolderChartLine } from "react-icons/ri";
import LoadAnalysis from "../General/LoadAnalysis";
import { setEditTarget } from "../../store/components/BuildTargets.slice";
import { setDisplayMode } from "../../store/components/Main.slice";
import Container from "../General/Container/Container";
import { isAdmin } from "../../utils/MainHelper";

const BuildTargetsHeader = function () {
    const dispatch = useDispatch();
    const [showLoadReport, setShowLoadReport] = useState(false);
    const { editTarget } = useSelector((state) => state.buildTargets);
    const { mode, modeOptions } = useSelector((state) => state.main);
    const showModeDisplay = modeOptions.filter((opt) => !opt.disabled)
    const [useInternalLink, setUseInternalLink] = useState(
        window.useInternalLink
    );
    const [useS3Cache, setUseS3Cache] = useState(window.useS3Cache)

    return (
        <div className="buildtargets-header-container">
            <b>Build Targets</b>
            <Container className="drow align-center gap-1">
                {(showModeDisplay.length > 1) ? <>

                    <div
                        style={{
                            display: "flex",
                            flexFlow: "row",
                            alignItems: "center",
                            gap: "2mm"
                        }}
                    >
                        <span>Mode: </span>
                        <Radio.Group
                            options={modeOptions}
                            onChange={(e) => {
                                dispatch(setDisplayMode(e.target.value))
                            }}
                            value={mode}
                            optionType="button"
                            buttonStyle="solid"
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexFlow: "row",
                            alignItems: "center",
                            gap: "2mm"
                        }}
                    >
                        <span style={{ flex: 1 }}>Use Internal link:</span>
                        <Switch size="small" value={useInternalLink} onChange={(e) => {
                            setUseInternalLink(e)
                            window.useInternalLink = e;
                        }} />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexFlow: "row",
                            alignItems: "center",
                            gap: "2mm"
                        }}
                    >
                        <span style={{ flex: 1 }}>Use S3 Cache:</span>
                        <Switch size="small" value={useS3Cache} onChange={(e) => {
                            setUseS3Cache(e)
                            window.useS3Cache = e;
                        }} />
                    </div>
                </>
                    : null}
                <Button
                    onClick={() => {
                        setShowLoadReport(true);
                    }}
                >
                    <div className="d-flex align-items-center gap-5p">
                        <RiFolderChartLine />
                        <span>
                            Load Dashboard
                        </span>
                    </div>
                </Button>
                {editTarget && (
                    <Button
                        style={{ marginLeft: "2mm" }}
                        danger
                        type="text"
                        icon={<CloseOutlined />}
                        onClick={() => {
                            dispatch(setEditTarget(false));
                        }}
                    />
                )}
            </Container>
            <LoadAnalysis
                visible={showLoadReport}
                onClose={setShowLoadReport}
            />
        </div>
    );
};

export default BuildTargetsHeader;
